<template>
    <v-card-text class="fill-height ma-0 pa-0">
        <v-card-title class="mt-0 pb-0 pa-0 justify-center" v-if="city">
            <v-row class="ma-2 mt-0 pa-0" style="width: 100%;">
                <v-col cols="8" >
                    <v-img
                        :src="require(`@/assets/pic/web/Officer_Jenny.png`)"
                        width="100%"
                        cover
                        max-height="300"
                        class="justify-center"
                    >
                        <v-card-title class="justify-center">
                            <div class="v-btn v-btn--contained title-btn v-btn--rounded theme--dark v-size--default text-transform: uppercase title-button">
                                {{ $t('journey.officerJenny.title') }}
                            </div>
                        </v-card-title>

                    </v-img>
                </v-col>
                <v-col cols="4" >
                    <v-card>
                        <v-img
                            class="self-center"
                            :src="require(`@/assets/pic/city/${city.id}.png`)"
                            cover
                            max-height="300"
                            width="100%"
                            height="100%"
                        >
                            <Tile
                                max-height="300"
                                :data="{action: city.name , text: '', button: $t('journey.officerJennyLegacy.backToCity', {city: $t('common.cityNames.' + city.name)}),back: true}"
                                :action="backToCity"
                                button-color="warning"
                            />
                        </v-img>
                    </v-card >
                </v-col>
            </v-row>
        </v-card-title>

        <v-card-text style="margin-left:40px;">

            <v-row>
                <v-col cols="4" class="ma-0" v-for="pokemon in pokemonsToUse" :key="pokemon.id ? pokemon.id : '0'">
                    <v-card-text class="ml-0 mr-0 pa-0">
                        <v-card v-if="pokemon === 1" class="pa-0 ma-0">
                            <v-img
                                class="self-center"
                                :src="require(`@/assets/pic/web/Officer_Jenny.png`)"
                                cover
                                max-height="300"
                                width="100%"
                                height="100%"
                            >
                                <Tile
                                    max-height="300"
                                    :data="{action: $t('journey.officerJennyLegacy.investigationAction') , text: displayMessage, button: $t('journey.officerJenny.investigation'), back: false}"
                                    :action="findStolen"
                                    button-color="accent"
                                    :add-day-icon="true"
                                    :disable-allow="true"
                                    :disabled="stolenPokemonsCount === 0"
                                />
                            </v-img>
                        </v-card>

                        <PokemonManager
                            v-if="pokemon !== 1"
                            :pokemon-source="pokemon"
                            :height-image="300"
                        />
                    </v-card-text>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card-text>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Tile from '@/components/journey/positions/pieces/Tile';
import {API_ENTRYPOINT} from "@/config/entrypoint";
import PokemonManager from "@/components/pokemon/PokemonManager";

export default {
    components: {Tile, PokemonManager},
    props: {
        city:  {type: Object, default: null},
        position:  {type: Object, default: null},
        trainerId:  {type: Number, default: null},
    },
    data() {
        return {
            triedFound: false,
            pokemons: [],
            pokemonsToUse: [1],
            success: false,
            // null = zatim nehledano (zobrazi se defaultMessage), jinak bud
            // "Finding..." behem hledani, nebo hotova hlaska z backendu.
            message: null,
            searching: false,
            stolenPokemonsCount: 0,
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'journey/isLoading',
        }),
        // message v data() je i18n-neutralni (null, nebo hotovy text z backendu) -
        // preklad defaultni/hledaci hlasky resi tenhle computed, aby reagoval na
        // prepnuti jazyka (viz i18n-conventions.md, bod 4).
        displayMessage() {
            if (this.searching) {
                return this.$t('journey.officerJennyLegacy.finding');
            }
            if (this.message !== null) {
                return this.message;
            }
            return this.$t('journey.officerJennyLegacy.defaultMessage');
        },
    },
    created() {
        this.trainerInfoMessages(this.trainerId).then(
            () => {
                this.stolenPokemonsCount = this.position.trainer.stolenPokemonsCount
            }
        );

    },
    methods: {
        ...mapActions({
            positionPost: 'journey/positionPost',
            trainerInfoMessages: 'trainer/loadInfoMessages',
            findStonePokemons: 'journey/findStonePokemons',
        }),
        backToCity(){
            const url = new URL("api/travel", API_ENTRYPOINT);
            const obj = {url: url, obj:{positionId: this.position.id, cityId: this.city.id},method:'POST'}
            this.positionPost(obj);
        },
        findStolen(){
            this.searching = true;
            this.success = false;

            let obj = {trainerId: this.trainerId, position: this.position}
            this.findStonePokemons(obj).then(
                (data) => {
                    this.searching = false;
                    let newPokemons = JSON.parse(JSON.stringify(this.pokemons));
                    for(let index in data.pokemons){
                        newPokemons.unshift(data.pokemons[index]);
                    }
                    this.pokemons = newPokemons;
                    this.pokemonsToUse = JSON.parse(JSON.stringify(newPokemons));
                    this.pokemonsToUse.unshift(1);
                    this.success = data.pokemons.length > 0;
                    this.stolenPokemonsCount = data.missing;
                    if (data.missing === 0) {
                      // Mrtvy kod - vsechny existujici testovaci sceny maji missing>0
                      // po prvnim volani (viz i18n audit 2026-08-25), ponechano beze zmeny.
                      this.message = 'Great! We found all your stolen pokémons!';
                    } else {
                      this.message = data.message;
                    }
                    this.triedFound = true;
                }
            );
        },
    },
}
</script>

